import { render, staticRenderFns } from "./LinkButton.vue?vue&type=template&id=b48e165c&"
import script from "./LinkButton.vue?vue&type=script&lang=js&"
export * from "./LinkButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b48e165c')) {
      api.createRecord('b48e165c', component.options)
    } else {
      api.reload('b48e165c', component.options)
    }
    module.hot.accept("./LinkButton.vue?vue&type=template&id=b48e165c&", function () {
      api.rerender('b48e165c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/customDocuments/components/LinkButton.vue"
export default component.exports